import { render, staticRenderFns } from "./fodder copy.vue?vue&type=template&id=047bef68"
import script from "./fodder copy.vue?vue&type=script&lang=js"
export * from "./fodder copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports